import React from "react";
import { Link, NavLink } from "react-router-dom";
import "./Navbar.css";
import RADLOGO from "../images/RADLOGO.jpeg";

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg fixed-top solar-grid-navbar">
      <div className="container">

        {/* BRAND */}
        <Link className="navbar-brand solar-brand" to="/">
          <img src={RADLOGO} alt="RAD EnviroNex" />
          <span>RAD ENVIRONEX</span>
        </Link>

        {/* TOGGLER */}
        <button
          className="navbar-toggler solar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#solarNav"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* MENU */}
        <div className="collapse navbar-collapse justify-content-end" id="solarNav">
          <ul className="navbar-nav align-items-lg-center solar-grid-menu">

            <li className="nav-item">
              <NavLink to="/" className={({ isActive }) => isActive ? "nav-link solar-active" : "nav-link"}>
                Home
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink to="/About" className={({ isActive }) => isActive ? "nav-link solar-active" : "nav-link"}>
                About
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink to="/Services" className={({ isActive }) => isActive ? "nav-link solar-active" : "nav-link"}>
                Services
              </NavLink>
            </li>

            {/* <li className="nav-item">
              <NavLink to="/Gallery" className={({ isActive }) => isActive ? "nav-link solar-active" : "nav-link"}>
                Gallery
              </NavLink>
            </li> */}

            <li className="nav-item">
              <a href="tel:+919597839564" className="nav-link solar-phone">
                <i className="fa fa-phone me-1"></i> +91 95978 39564
              </a>
            </li>

            <li className="nav-item ms-lg-3">
              <NavLink to="/Contact" className="solar-contact">
                Contact
              </NavLink>
            </li>

          </ul>
        </div>

      </div>
    </nav>
  );
}
